import { useMediaQuery } from 'react-responsive';

// Our actual breakpoints are defined in +_breakpoints.scss+ do not change the pixel values in this file unless the
// global breakpoints are being changed
// We don't have a variable for each possible breakpoint simply because we don't need them all
// https://github.com/yocontra/react-responsive
//
export function useScreenSize() {
  const isTinyScreenSize = useMediaQuery({ maxWidth: 480 });
  const isSmallScreenSize = useMediaQuery({ maxWidth: 768 });
  const isMediumScreenSize = useMediaQuery({ minWidth: 1024 });
  const isLargeScreenSize = useMediaQuery({ minWidth: 1280 });
  const isGreaterThanLargeScreenSize = useMediaQuery({ minWidth: 1600 });

  return {
    isTinyScreenSize,
    isSmallScreenSize,
    isMediumScreenSize,
    isLargeScreenSize,
    isGreaterThanLargeScreenSize,
  };
}
